var map = {
	"./GAC04943-Migliorato-NR (2).jpg": 1580,
	"./GAC04961-Migliorato-NR (2).jpg": 5192,
	"./GAC04977-Migliorato-NR (2).jpg": 8513,
	"./GAC04987 (2).jpg": 4203,
	"./GAC05017 (2).jpg": 7122,
	"./GAC05085 (1).jpg": 2738,
	"./GAC05184 (1).jpg": 9578,
	"./GAC05445 (1).jpg": 9226,
	"./HGAC04991 (2).jpg": 8726,
	"./HGAC05384 (1).jpg": 2828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2964;